var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 303,
    height: 111,
    fill: "#520DC2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6051 41.1818H34.0824L54.8097 91.7727H55.6278L76.3551 41.1818H91.8324V111H79.696V63.0341H79.0483L59.7528 110.795H50.6847L31.3892 62.9318H30.7415V111H18.6051V41.1818ZM105.605 111V41.1818H131.787C137.151 41.1818 141.651 42.1818 145.287 44.1818C148.946 46.1818 151.707 48.9318 153.571 52.4318C155.457 55.9091 156.401 59.8636 156.401 64.2955C156.401 68.7727 155.457 72.75 153.571 76.2273C151.685 79.7045 148.901 82.4432 145.219 84.4432C141.537 86.4205 137.003 87.4091 131.616 87.4091H114.264V77.0114H129.912C133.048 77.0114 135.616 76.4659 137.616 75.375C139.616 74.2841 141.094 72.7841 142.048 70.875C143.026 68.9659 143.514 66.7727 143.514 64.2955C143.514 61.8182 143.026 59.6364 142.048 57.75C141.094 55.8636 139.605 54.3977 137.582 53.3523C135.582 52.2841 133.003 51.75 129.844 51.75H118.253V111H105.605ZM167.386 111V41.1818H212.795V51.7841H180.034V70.7386H210.443V81.3409H180.034V100.398H213.068V111H167.386ZM272.472 63.4773C271.903 61.6364 271.119 59.9886 270.119 58.5341C269.142 57.0568 267.96 55.7955 266.574 54.75C265.21 53.7045 263.642 52.9205 261.869 52.3977C260.097 51.8523 258.165 51.5795 256.074 51.5795C252.324 51.5795 248.983 52.5227 246.051 54.4091C243.119 56.2955 240.813 59.0682 239.131 62.7273C237.472 66.3636 236.642 70.7955 236.642 76.0227C236.642 81.2955 237.472 85.7614 239.131 89.4205C240.79 93.0795 243.097 95.8636 246.051 97.7727C249.006 99.6591 252.438 100.602 256.347 100.602C259.892 100.602 262.96 99.9205 265.551 98.5568C268.165 97.1932 270.176 95.2614 271.585 92.7614C272.994 90.2386 273.699 87.2841 273.699 83.8977L276.562 84.3409H257.608V74.4545H285.938V82.8409C285.938 88.8182 284.665 93.9886 282.119 98.3523C279.574 102.716 276.074 106.08 271.619 108.443C267.165 110.784 262.051 111.955 256.278 111.955C249.847 111.955 244.199 110.511 239.335 107.625C234.494 104.716 230.71 100.591 227.983 95.25C225.278 89.8864 223.926 83.5227 223.926 76.1591C223.926 70.5227 224.722 65.4886 226.312 61.0568C227.926 56.625 230.176 52.8636 233.062 49.7727C235.949 46.6591 239.335 44.2955 243.222 42.6818C247.108 41.0455 251.335 40.2273 255.903 40.2273C259.767 40.2273 263.369 40.7955 266.71 41.9318C270.051 43.0455 273.017 44.6364 275.608 46.7045C278.222 48.7727 280.369 51.2273 282.051 54.0682C283.733 56.9091 284.835 60.0455 285.358 63.4773H272.472Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_649)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 233,
    width: 164,
    height: 167,
    fill: "#FAFAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 194C167.914 194 112 249.907 112 319C112 388.087 167.906 444 237 444C306.087 444 362 388.093 362 319C362 249.913 306.093 194 237 194ZM282.038 332.876L223.301 366.815C218.346 369.678 212.236 369.683 207.272 366.819C202.312 363.957 199.257 358.666 199.257 352.939V285.061C199.257 279.334 202.313 274.043 207.272 271.181C209.751 269.75 212.517 269.035 215.283 269.035C218.052 269.035 220.821 269.752 223.301 271.185L282.039 305.124C286.994 307.987 290.046 313.276 290.046 319C290.046 324.724 286.994 330.012 282.038 332.876Z",
    fill: "#520DC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_649",
    x: 6.60547,
    y: 40.2266,
    width: 283.332,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "translate(112 194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpeg);
export default __webpack_public_path__ + "static/media/mpeg.591b7f60d54d6656cf24ed18fe8dbe69.svg";
export { ForwardRef as ReactComponent };